import { boolean as yupBoolean, mixed, object, string } from 'yup';

import { SourcesProvider, SourcesAuthType } from '@api/types.gen';

export interface SettingsFormValues {
  name: string;
  url: string;
  tlsSkipVerify: boolean;
  authEnabled: boolean;
  provider: SourcesProvider;
  type: SourcesAuthType;
  username: string;
  password: string;
}

export const validationSchema = object({
  name: string().required('Name is required'),
  url: string().required('Repository URL is required'),
  tlsSkipVerify: yupBoolean().defined(),
  authEnabled: yupBoolean().defined(),
  provider: mixed<SourcesProvider>()
    .oneOf(Object.values(SourcesProvider))
    .defined(),
  type: mixed<SourcesAuthType>()
    .oneOf(Object.values(SourcesAuthType))
    .defined(),
  username: string().when('authEnabled', {
    is: true,
    then: (schema) => schema.required('Username is required'),
    otherwise: (schema) => schema.optional(),
  }),
  password: string().optional(),
});
